import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

interface PaymentMethodButtonBoxType {
    isSignup: boolean;
}

export const PaymentMethodButtonBox = withConfig(theme => styled('button', { label: 'PaymentMethodButtonBox' }) <PaymentMethodButtonBoxType>`
    align-items: center;
    background: ${({ isSignup }): string => (isSignup ? theme.star.paymentMethod.dark.bgColor : theme.star.paymentMethod.light.bgColor)};
    border: none;
    color: ${({ isSignup }): string => (isSignup ? theme.star.paymentMethod.dark.txtColor : theme.star.paymentMethod.light.txtColor)};
    cursor: pointer;
    display: flex;
    height: 48px;
    width: 100%;
    padding: 12px;
    position: relative;
    transition: all 0.2s ease;

    &:disabled {
        color: ${({ isSignup }): string => (isSignup ? theme.star.paymentMethod.dark.txtColor : theme.star.paymentMethod.light.txtColorSecondary)};
        cursor: not-allowed;
        opacity: 0.6;
    }

    &:focus {
        outline: 2px solid ${theme.star.paymentMethod.bgColor};
        outline-offset: 2px;
    }

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: black;
        opacity: 0;
        transition: opacity 0.2s ease;
        pointer-events: none;
        border-radius: inherit;
    }

    &:not(:disabled):hover::after {
        opacity: 0.1;
    }

    &:not(:disabled):active::after {
        opacity: 0.2;
    }
`);
